const translations = {
    flightControllerSerial: 'Flight Controller Serial',
    registrationNumber: 'Registration Number',
    swathWidth: 'Swath Width: {{width}} m'
};

export default translations;
